import React, { memo, useState } from 'react';
import { Col, Row } from 'reactstrap';
import moment from 'moment';

import CustomModal from '../../components/GeneralForm/CustomModal';
import MultiRoleDatePicker, {
  PICKERTYPE_DATERANGE_TWOMONTH
} from '../../components/GeneralForm/MultiRoleDatePicker';
import { showMsg } from '../../services/library';
import CommonService from '../../services/commonService';
import { DATE_FORMAT_YMD } from '../../constants/dateFormatsConst';

const ImportReportModal = props => {
  let userData = (props && props?.user) || null;
  let dealerData = (props && props?.dealer) || null;

  const [fromDate, setFromDate] = useState(moment().toDate());
  const [toDate, setToDate] = useState(moment().toDate());

  // send report
  const handleInstantImportReport = async () => {
    props.handleLayoutLoader(true);
    try {
      const response = await CommonService.sendInstantImportReport({
        dealer_id: dealerData?.value,
        fromDate: moment(fromDate).format(DATE_FORMAT_YMD),
        toDate: moment(toDate).format(DATE_FORMAT_YMD)
      });
      if (response.status) {
        showMsg(response.message, 'success');
        props.toggle();
      } else {
        showMsg(response.errors, 'error');
      }
    } catch (error) {
      showMsg(error, 'error');
    } finally {
      props.handleLayoutLoader(false);
    }
  };

  return (
    <CustomModal
      isOpen={props.isOpen}
      closeClick={props.toggle}
      modalScrollable={false}
      modalSize="md"
      saveClick={handleInstantImportReport}
      submitButtonName="Send"
      modalTitle="5PM Report"
      modalBackDrop="static"
    >
      <div className="px-2 py-3">
        <div className=" p-3 bg-light">
          <Row className="mb-3">
            <Col sm="4">Recipient :</Col>
            <Col sm="8">{userData?.user_email || 'logged in user email'}</Col>
          </Row>

          <Row className="mb-3">
            <Col sm="4">Dealership :</Col>
            <Col sm="8">{dealerData?.label}</Col>
          </Row>
          <Row>
            <Col sm="4">Date :</Col>
            <Col sm="8">
              <MultiRoleDatePicker
                id="report_range"
                startDate={fromDate}
                endDate={toDate}
                onChange={date => {
                  const [start, end] = date;
                  setFromDate(start);
                  setToDate(end);
                }}
                setStartDate={date => setFromDate(date)}
                setEndDate={date => setToDate(date)}
                pickerType={PICKERTYPE_DATERANGE_TWOMONTH}
                buttonIcon="fa-envelope mr-2"
                buttonIsOutline={false}
                isDateTextShown={true}
                toolTipText="Send 5 PM Report"
              />
            </Col>
          </Row>
        </div>
      </div>
    </CustomModal>
  );
};

ImportReportModal.displayName = 'ImportReportModal';
export default memo(ImportReportModal);
